import styled from 'styled-components';
import { Children, useState, useEffect } from 'react';
import { RowTable } from '../../../../func/components/Table';
import { NumberwithComma, ReportFormatNumber } from '../../../../func/Function';
import { useReportContext } from '../../../../context/DetailContext';
import { BasicInfoProps } from '../../data';
import { AFileList, PFileList, ACommonList } from '../../../../sidebar';
import { SButton2 } from '../../../../sidebar/SButton';
import LoanInfoService from '../../../../service/LoanInfo';
import ListContent, { ListData } from '../ListContent';
const attachmentIcon = '/assets/images/icon/Icon_Attachment.svg';

const BasicInfo = ({
  data,
  linkSet,
  caseInfo,
  basicInfo,
}: {
  data: any;
  basicInfo?: any;
  linkSet?: any;
  caseInfo?: any;
  assetDetailLink?: string;
}) => {
  const { type } = useReportContext();
  const [itemDetailButtonOn, setItemDetailButtonOn] = useState<boolean>(false);
  const [casDetailButtonOn, setCasDetailButtonOn] = useState<boolean>(false);
  const [dateDetailButtonOn, setDateDetailButtonOn] = useState<boolean>(false);
  useEffect(() => {
    if (type === 's') {
      return;
    }
    if (caseInfo?.iidx) {
      getData(Number(caseInfo?.iidx));
    }
  }, [type]);

  if (!data) return null;

  if (!data) {
    console.log('BasicInfo: data is null or undefined');
    return null;
  }

  const list = ACommonList(
    caseInfo,
    itemDetailButtonOn,
    casDetailButtonOn,
    dateDetailButtonOn,
  );

  const targetItem = list.find((item) => item.title === '물건상세');

  const formatAreaData = (data: any, unit: string, data_p?: any) => {
    if (!data) return '-';
    if (typeof data === 'string' && data.toString().includes('지분')) {
      // 전체 제곱미터
      const totalMatch = data.match(/전체:\s*([\d.]+)\s*㎡/);
      // 지분 제곱미터
      const shareMatch = data.match(/지분:\s*([\d.]+)\s*(㎡|m²)/);

      const total = totalMatch ? parseFloat(totalMatch[1]) : null;
      const share = shareMatch ? parseFloat(shareMatch[1]) : null;

      if (total === null || share === null) return;

      let totalStr = '';
      let shareStr = '';

      if (unit === 'p') {
        totalStr = (total / 3.3058).toFixed(1);
        shareStr = (share / 3.3058).toFixed(1);
        return `전체: ${totalStr}평\n지분: ${shareStr}평`;
      } else {
        totalStr = total.toFixed(1);
        shareStr = share.toFixed(1);
        return `전체: ${totalStr}㎡\n지분: ${shareStr}㎡`;
      }
    } else if (/[0-9]/g.test(data)) {
      if (unit === 'p') {
        return `${data_p}평`;
      } else {
        return `${data.toFixed(1)}㎡`;
      }
    } else {
      return '-';
    }
  };

  const rendingData: ListData[] = [
    { label: '지번주소', value: data.address, isAddress: true },
    {
      label: '도로명주소',
      value: caseInfo?.roadnamelocation || '도로명 주소 없음',
      isAddress: caseInfo?.roadnamelocation && true,
    },
    { label: '물건종별', value: data.category },
    {
      label: '감정가',
      value: `${ReportFormatNumber(data.appraisalPrice)}`,
      isBold: true,
    },
    {
      label: '최저가',
      value: `${ReportFormatNumber(data.minimumPrice)}`,
      hasPercentBadge: true,
      percent: data.minimumPricePerAppraisalPrice,
      isBold: true,
    },
    {
      label: '보증금',
      value: `${ReportFormatNumber(data.deposit)}`,
      hasPercentBadge: true,
      percent: '10',
    },
    {
      label: '토지면적',
      value: formatAreaData(data.landArea, 'm'),
      isArea: true,
      value_p: formatAreaData(data.landArea, 'p', data.landAreaPyoeng),
      hasToggleButton: true,
      deleteAreaUnit: true,
    },
    data.buildingArea && {
      label: '건물면적(전용)',
      isArea: true,
      value: formatAreaData(data.buildingArea, 'm'),
      value_p: formatAreaData(data.buildingArea, 'p', data.buildingAreaPyoeng),
      deleteAreaUnit: true,
    },
    { label: '매각물건', value: data.saleItem },
    { label: '소유자', value: data.owner },
  ].filter(Boolean) as ListData[];
  const PAuctionRendingData: ListData[] = [
    { label: '용도', value: data.category },
    { label: '처분방식', value: data.saleItem },
    { label: '입찰방식', value: data.bidMethod },
    { label: '자산구분', value: data.assetClass },
    { label: '입찰기간', value: data.biddate },
    {
      label: '감정가',
      value: `${ReportFormatNumber(data.appraisalPrice)}`,
      isBold: true,
    },
    {
      label: '최저가',
      value: `${ReportFormatNumber(data.minimumPrice)}`,
      hasPercentBadge: true,
      percent: data.minimumPricePerAppraisalPrice,
      isBold: true,
    },
    { label: '유찰횟수', value: data.bidCount },
    { label: '집행기관', value: data.courtName },
    {
      label: '토지면적',
      value: data.landArea,
      isArea: true,
      value_p: data.landAreaPyoeng,
      hasToggleButton: true,
    },
    data.buildingArea && {
      label: '건물면적(전용)',
      value: data.buildingArea,
      isArea: true,
      value_p: data.buildingAreaPyoeng,
    },
    { label: '담당자정보', value: data.manager },
  ].filter(Boolean) as ListData[];

  const RenderData = () => {
    if (type === 'a') {
      return rendingData;
    } else {
      return PAuctionRendingData;
    }
  };

  const getData = async (iidx: number) => {
    try {
      const res = await LoanInfoService.courtDetail(iidx);
      if (res.data.item_detail.basic_info.case_no !== null) {
        setItemDetailButtonOn(true);
      }
      if (res.data.case_detail.basic_info.case_no !== null) {
        setCasDetailButtonOn(true);
      }
      if (res.data.date_list !== null) {
        setDateDetailButtonOn(true);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Container id="물건기본정보">
      <TitleBox>
        물건 기본정보
        {targetItem && targetItem.link && (
          <DetailButton
            onClick={() => {
              if (targetItem?.link) {
                window.open(targetItem.link, '_blank');
              }
            }}
          >
            {targetItem && targetItem.title} 보기 {'>'}
          </DetailButton>
        )}
      </TitleBox>
      <ListContent data={RenderData()} />
    </Container>
  );
};

export default BasicInfo;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  background-color: #fff;
  gap: 16px;
`;
const TitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const DetailButton = styled.button`
  padding: 5px 10px;
  border-radius: 8px;
  background: #0220470d;
  border: none;

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #3e5463;
`;
